import { render, staticRenderFns } from "./PlayerSummary.vue?vue&type=template&id=674eab5a&scoped=true&"
import script from "./PlayerSummary.vue?vue&type=script&lang=js&"
export * from "./PlayerSummary.vue?vue&type=script&lang=js&"
import style0 from "./PlayerSummary.vue?vue&type=style&index=0&id=674eab5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674eab5a",
  null
  
)

export default component.exports